import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { api, fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            setError(fmtErr(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F8FAF9] flex items-center justify-center px-4">
            <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm animate-fade-up" data-testid="forgot-password-card">
                {sent ? (
                    <div className="text-center py-4">
                        <MailCheck className="h-12 w-12 text-[#E06D1F] mx-auto" />
                        <h2 className="mt-4 font-heading text-xl font-bold text-slate-900">Check your inbox</h2>
                        <p className="mt-2 text-sm text-slate-500">If that email is registered, a reset link has been sent. The link expires in 1 hour.</p>
                        <Link to="/login" data-testid="back-to-login-link" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#C2410C] hover:underline">
                            <ArrowLeft className="h-4 w-4" /> Back to sign in
                        </Link>
                    </div>
                ) : (
                    <>
                        <h2 className="font-heading text-2xl font-bold text-slate-900">Reset password</h2>
                        <p className="mt-1 text-sm text-slate-500">Enter your registered doctor email</p>
                        <form onSubmit={submit} className="mt-6 space-y-4">
                            <div className="space-y-1.5">
                                <Label>Email</Label>
                                <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="doctor@clinic.com" />
                            </div>
                            {error && <p data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
                            <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full bg-[#E06D1F] hover:bg-[#B45309] text-white">
                                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
                            </Button>
                        </form>
                        <Link to="/login" data-testid="back-to-login-link" className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#C2410C] hover:underline">
                            <ArrowLeft className="h-4 w-4" /> Back to sign in
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
